import React, { Component } from "react";
import AntdRadio, { RadioProps, RadioGroupProps } from "antd/lib/radio";
import "antd/lib/radio/style";
import PagePoint from "../page-point/pagePointEnhanced";
import { ConfigConsumer, ConfigConsumerEProps } from "../config-provider";

const { Group:AntdRadioGroup, Button } = AntdRadio;
 class Radio extends Component<RadioProps> {
  static Button = Button;
//   static Group = PagePointHOC(Group, "RadioGroup");
  static Group: typeof RadioGroup;

  render() {
    const { children } = this.props;
    return (
      <ConfigConsumer>
        {({ pagePoint }: ConfigConsumerEProps) =>
          pagePoint ? (
            <PagePoint
              compType="Radio"
              {...this.props}
              render={eventprops => (
                <AntdRadio {...this.props} {...eventprops} data-ui-role='Radio'>
                  {children}
                </AntdRadio>
              )}
            ></PagePoint>
          ) : (
            <AntdRadio {...this.props}>{children}</AntdRadio>
          )
        }
      </ConfigConsumer>
    );
  }
}


class RadioGroup extends Component<RadioGroupProps> {

    render() {
        const { children } = this.props;
        return (
          <ConfigConsumer>
            {({ pagePoint }: ConfigConsumerEProps) =>
              pagePoint ? (
                <PagePoint
                  compType="RadioGroup"
                  {...this.props}
                  render={eventprops => (
                    <AntdRadioGroup {...this.props} {...eventprops} data-ui-role='RadioGroup'>
                      {children}
                    </AntdRadioGroup>
                  )}
                ></PagePoint>
              ) : (
                <AntdRadioGroup {...this.props}>{children}</AntdRadioGroup>
              )
            }
          </ConfigConsumer>
        );
      }
}

Radio.Group = RadioGroup;

export default Radio;


// WEBPACK FOOTER //
// ./src/components/radio/index.tsx